<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="box_1 flex-col" style="border-radius: 28px">
        <div class="box_2 flex-col" >
          <div class="login-form" style="margin-top:60px">
            <div class="form-item" style="text-align: justify;margin-left: 28%">
              <span class="text_1" style="font-size: 2.8vw;font-family: PingFangSC-Medium;font-weight: 500;color: rgba(51, 51, 51, 1);">登录</span>
            </div>
            <div class="form-item" style="margin-top: 10px">

              <div>

              </div>
              <span class="text_1">姓名</span>
              <el-input
                v-model="loginForm.username"
                placeholder="请输入姓名"
                class="text-wrapper_1"
                size="medium"
                @keyup.enter.native="handleLogin"
              ></el-input>
            </div>
            <div class="form-item">
              <span class="text_3">手机号</span>
              <el-input
                v-model="loginForm.password"
                type="text"
                placeholder="请输入手机号"
                class="text-wrapper_2"
                size="medium"
                @keyup.enter.native="handleLogin"
              ></el-input>
            </div>
            <!-- <div class="form-item" v-if="showPosition">
              <span class="text_5">岗位</span>
              <el-select
                v-model="loginForm.position"
                placeholder="请选择岗位"
                class="section_1"
                size="medium"
              >
                <el-option
                  v-for="item in positionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
<!--            <div class="text-wrapper_3 flex-col"></div>-->

            <div class="form-item">
              <el-button
                type="primary"
                class="text-wrapper_3 flex-col"
                size="medium"
                :loading="loginLoading" style="background-color: rgba(27, 155, 113, 1);"
                @click="handleLogin"
              >
                <span class="text_7">进入</span>
              </el-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { login, getTenantIdByName, getTenantByWebsite, getUserInfo as getUserInfoApi } from '@/api/login'
import { setToken, setLoginForm, removeLoginForm, setTenantId, getTenantId, getLoginForm, setUserInfo } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loginLoading: false,
      showPosition: false, // 是否显示岗位选择（可根据业务需求调整）
      isPCDevice: true, // 是否为PC设备
      loginForm: {
        username: process.env.VUE_APP_DEFAULT_LOGIN_USERNAME || '',
        password: process.env.VUE_APP_DEFAULT_LOGIN_PASSWORD || '',
        captchaVerification: '',
        rememberMe: true,
        tenantName: process.env.VUE_APP_DEFAULT_LOGIN_TENANT || '',
        position: ''
      },
      positionOptions: [
        { label: 'UI工程师', value: 'UI工程师' },
        { label: '前端工程师', value: '前端工程师' },
        { label: 'Java工程师', value: 'Java工程师' },
        { label: '后端工程师', value: '后端工程师' }
      ],
      tenantEnable: (process.env.VUE_APP_TENANT_ENABLE || 'false') === 'true',
      captchaEnable: (process.env.VUE_APP_CAPTCHA_ENABLE || 'false') === 'true'
    }
  },
  created() {
    console.log('Login component created')
    // 检测是否为PC端 - 在 created 阶段执行，确保尽早检测
    this.checkIsPC()
  },
  mounted() {
    console.log('Login component mounted')
    // 获取缓存的登录信息
    this.getLoginFormCache()
    // 根据域名获取租户信息
    this.getTenantByWebsite()
  },
  methods: {
    // 检测是否为PC端
    checkIsPC() {
      console.log('checkIsPC 方法被调用')
      
      try {
        // 方法1: 检测 user agent
        const userAgent = navigator.userAgent.toLowerCase()
        console.log('User Agent:', userAgent)
        const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone', 'mobile']
        const isMobileByUA = mobileKeywords.some(keyword => userAgent.includes(keyword))
        
        // 方法2: 检测屏幕宽度（移动端通常小于768px）
        const isMobileByWidth = window.innerWidth < 768
        console.log('isMobileByUA:', isMobileByUA, 'isMobileByWidth:', isMobileByWidth, 'window.innerWidth:', window.innerWidth)
        
        // 如果任一条件满足，则认为是移动端
        if (isMobileByUA || isMobileByWidth) {
          console.log('检测到移动设备，显示提示')
          this.isPCDevice = false
          // 使用 setTimeout 确保 DOM 已渲染
          setTimeout(() => {
            if (this.$alert) {
              this.$alert('请在电脑端打开网站', '提示', {
                confirmButtonText: '确定',
                showClose: false, // 不显示关闭按钮
                closeOnClickModal: false, // 点击遮罩层不关闭
                closeOnPressEscape: false, // 按ESC不关闭
                callback: () => {
                  // 点击确定后再次显示弹窗，确保无法关闭
                  setTimeout(() => {
                    this.checkIsPC()
                  }, 100)
                }
              })
            } else {
              // 如果 $alert 不可用，使用 alert
              alert('请在电脑端打开网站')
              setTimeout(() => {
                this.checkIsPC()
              }, 100)
            }
          }, 100)
        } else {
          console.log('检测到PC设备')
          this.isPCDevice = true
        }
      } catch (error) {
        console.error('checkIsPC 执行出错:', error)
      }
    },
    // 获取缓存的登录表单
    getLoginFormCache() {
      const loginForm = getLoginForm()
      if (loginForm) {
        this.loginForm = {
          ...this.loginForm,
          username: loginForm.username || this.loginForm.username,
          password: loginForm.password || this.loginForm.password,
          rememberMe: loginForm.rememberMe !== undefined ? loginForm.rememberMe : this.loginForm.rememberMe,
          tenantName: loginForm.tenantName || this.loginForm.tenantName
        }
      }
    },
    // 根据域名获取租户信息
    async getTenantByWebsite() {
      if (this.tenantEnable) {
        try {
          const website = location.host
          const res = await getTenantByWebsite(website)
          if (res) {
            // res 已经是后端返回的数据（可能是对象或数字）
            if (typeof res === 'object' && res.name) {
              this.loginForm.tenantName = res.name
              setTenantId(res.id)
            }
          }
        } catch (error) {
          console.error('获取租户信息失败:', error)
        }
      }
    },
    // 获取租户ID
    async getTenantId() {
      if (this.tenantEnable && this.loginForm.tenantName) {
        try {
          const res = await getTenantIdByName(this.loginForm.tenantName)
          if (res !== undefined && res !== null) {
            // res 可能是数字（租户ID）或对象
            const tenantId = typeof res === 'object' ? res.id : res
            if (tenantId) {
              setTenantId(tenantId)
            }
          }
        } catch (error) {
          console.error('获取租户ID失败:', error)
          throw error
        }
      }
    },
    // 登录
    async handleLogin() {
      // 表单验证
      if (!this.loginForm.username) {
        this.$message.warning('请输入用户名')
        return
      }
      if (!this.loginForm.password) {
        this.$message.warning('请输入密码')
        return
      }

      this.loginLoading = true
      const loading = this.$loading({
        lock: true,
        text: '正在登录...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 获取租户ID（如果租户功能未开启，设置默认值 1）
        await this.getTenantId()
        // 确保租户ID已设置（如果没有，设置默认值 1）
        if (!getTenantId()) {
          setTenantId('1')
        }

        // 调用登录API
        const loginData = {
          username: this.loginForm.username,
          password: this.loginForm.password,
          tenantName:'芋道源码',
          rememberMe:true
          // captchaVerification: this.loginForm.captchaVerification
        }

        const res = await login(loginData)

        if (res) {
          // 保存token（res 已经是 token 对象，因为 request.js 的响应拦截器已经处理）
          setToken(res)

          // 获取用户信息并缓存
          try {
            const userInfo = await getUserInfoApi()
            if (userInfo) {
              setUserInfo(userInfo)
            }
          } catch (error) {
            console.error('获取用户信息失败:', error)
            // 即使获取用户信息失败，也不影响登录流程
          }

          // 记住我
          if (this.loginForm.rememberMe) {
            setLoginForm({
              username: this.loginForm.username,
              password: this.loginForm.password,
              rememberMe: this.loginForm.rememberMe,
              tenantName: this.loginForm.tenantName
            })
          } else {
            removeLoginForm()
          }

          this.$message.success('登录成功')

          // 跳转到首页或指定页面
          const redirect = this.$route.query.redirect || '/index'
          this.$router.push(redirect)
        }
      } catch (error) {
        console.error('登录失败:', error)
        // 错误信息已在 request.js 的拦截器中处理
      } finally {
        this.loginLoading = false
        loading.close()
      }
    }
  }
}
</script>
<style scoped lang="scss" src="./assets/index.scss" />
<style>
.text-wrapper_3 {
  background-color: rgba(27, 155, 113, 1);
  border-radius: 8px;
  height: 3.13vw;
  width: 24.02vw;
  margin: 3.12vw 0 7.03vw 59.68vw;
  .text_7 {
    width: 2.3vw;
    height: 1.57vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 1.14vw;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: justify;
    white-space: nowrap;
    line-height: 1.57vw;
  }
}
</style>
